/* eslint-disable import/no-cycle */
import { lazy } from "react";
import LoginJules from "components/svgs/loginJules";

import Heading from "hardcover-ui/components/Heading";
import Text from "hardcover-ui/components/Text";

const ReferrerBox = lazy(() => import("./ReferrerBox"));

export function NoReferrerBox() {
  return (
    <div className="flex items-center gap-4">
      <LoginJules className="w-32 mb-2" />
      <div>
        <Heading variant="primary" size="md" className="font-extrabold">
          Join Hardcover
        </Heading>
        <p>
          <Text variant="secondary">
            Sign up and enter a world of amazing books
          </Text>
        </p>
      </div>
    </div>
  );
}

export default function Referrer({ userId }: { userId?: number }) {
  return userId ? <ReferrerBox userId={userId} /> : <NoReferrerBox />;
}
